import { render, staticRenderFns } from "./entity-list.vue?vue&type=template&id=0cf28c24"
import script from "./entity-list.vue?vue&type=script&lang=js"
export * from "./entity-list.vue?vue&type=script&lang=js"
import style0 from "./entity-list.vue?vue&type=style&index=0&id=0cf28c24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports